export default {
  paged: {
    select:
      'id,isActive,status,canCreatePartners,canCreateResellers,canCreateCustomers,partnerAgreementMode',
    searchSelect: ['company/commercialName', 'company/identity', 'ownerCompany/commercialName'],
    orderBy: 'company/commercialName asc',
    expand: {
      company: {
        select: 'commercialName,identity',
      },
      ownerCompany: {
        select: 'commercialName',
      },
    },
  },
  itemDetail: {
    expand: {
      company: {
        select: 'commercialName,identity',
      },
      ownerCompany: {
        select: 'commercialName',
      },
      defaultPartnerAgreement: {
        select: 'name',
      },
      defaultResellerAgreement: {
        select: 'name',
      },
    },
  },
};
